import { AnimatePresence, HTMLMotionProps, motion } from 'framer-motion';
import { Backdrop } from 'library/backdrop';
import { CrossIcon } from 'library/icons';
import { FC, ForwardedRef, ReactNode, forwardRef } from 'react';
import { createPortal } from 'react-dom';
import ScrollLock from 'react-scrolllock';
import { twMerge } from 'tailwind-merge';
import { drawerAnimation } from '../helpers/drawer.animations';

export interface DrawerProps extends HTMLMotionProps<'div'> {
    show: boolean;
    children: ReactNode;
    onClose: () => void;
    ref?: ForwardedRef<HTMLDivElement>;
}
const Drawer = forwardRef<HTMLDivElement, DrawerProps>((props, ref) => {
    const { show, onClose, children, className, ...rest } = props;

    return createPortal(
        <AnimatePresence initial={false} mode="wait">
            {show && (
                <>
                    <Backdrop show={show} onClick={onClose} className="z-[80]" />

                    <ScrollLock>
                        <motion.div
                            {...rest}
                            {...drawerAnimation}
                            ref={ref}
                            className={twMerge(
                                'fixed right-0 top-0 bg-card-color max-w-full w-full md:w-[400px] h-full min-h-full overflow-x-hidden overflow-y-auto z-[81] p-6',
                                className
                            )}
                        >
                            <button
                                type="button"
                                className="absolute top-[26px] right-6 z-[82] btn-action"
                                onClick={onClose}
                            >
                                <CrossIcon className="w-3 h-3 text-grayscale-500" />
                            </button>

                            <div>{children}</div>
                        </motion.div>
                    </ScrollLock>
                </>
            )}
        </AnimatePresence>,
        document.getElementById('drawer-root')
    );
});

export default Drawer;
